/** Shared repo indexing filters and limits (client + server). */

export const ALLOW_EXT = new Set([
  '.ts', '.tsx', '.js', '.jsx', '.mjs', '.cjs',
  '.py', '.go', '.rs', '.rb', '.java', '.kt', '.swift', '.c', '.cpp', '.h',
  '.md', '.mdx',
  '.json', '.yaml', '.yml',
  '.sh', '.bash', '.zsh',
  '.css', '.scss', '.html', '.sql',
]);

export const SKIP_DIRS = new Set([
  'node_modules', 'dist', 'build', '.git', '.next', '.nuxt',
  'coverage', '__pycache__', '.cache', 'vendor', 'out',
  '.turbo', '.vercel', '.svelte-kit', 'target', 'bin', 'obj', '.expo',
]);

export const SKIP_FILES = new Set([
  'package-lock.json', 'yarn.lock', 'pnpm-lock.yaml', 'bun.lockb', 'Gemfile.lock', 'Cargo.lock',
]);

export const BINARY_EXT = new Set([
  '.png', '.jpg', '.jpeg', '.gif', '.ico', '.svg', '.webp',
  '.mp4', '.mp3', '.wav', '.zip', '.gz', '.tar', '.pdf', '.woff', '.woff2', '.ttf', '.eot',
]);

export const SMALL_FILE_THRESHOLD = 4096;
export const MAX_CHUNKS_PER_FILE = 40;
export const MAX_FILE_BYTES = 100 * 1024;
export const MAX_REPO_FILES = 2000;

/** Target chunk size: 512–1500 tokens ≈ 1700–5000 chars for code. */
export const TARGET_CHUNK_MIN_CHARS = 1700;
export const TARGET_CHUNK_MAX_CHARS = 5000;
export const CHUNK_OVERLAP_CHARS = 150;
export const FEATHERLESS_MAX_CHUNK_CHARS = 8000;

export const REPO_EMBED_BATCH_SIZE = 24;
export const REPO_EMBED_CONCURRENCY = 4;

export function shouldSkipPath(path: string): boolean {
  const lower = String(path).toLowerCase();
  const segments = lower.split('/');
  if (segments.some((seg) => SKIP_DIRS.has(seg))) return true;
  const filename = segments[segments.length - 1];
  if (SKIP_FILES.has(filename)) return true;
  const dot = filename.lastIndexOf('.');
  const ext = dot >= 0 ? filename.slice(dot) : '';
  if (BINARY_EXT.has(ext)) return true;
  return !ALLOW_EXT.has(ext);
}

export function fileExtension(path: string): string {
  const filename = path.split('/').pop() ?? path;
  const dot = filename.lastIndexOf('.');
  return dot >= 0 ? filename.slice(dot).toLowerCase() : '';
}

export function estimateCodeTokens(text: string): number {
  return Math.ceil(text.length / 3.3);
}
